import { ApplicationRef, Component, ComponentFactoryResolver, Injector, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';
declare const L: any;
import 'leaflet-draw';
import { LatLng } from 'leaflet';
import { LayerPopupComponent } from '../layer-popup/layer-popup.component';

@Component({
  selector: 'app-layer-object',
  templateUrl: './layer-object.component.html',
  styleUrls: ['./layer-object.component.css']
})
export class LayerObjectComponent implements OnInit {

  private map!: L.Map;
  private centroid: L.LatLngExpression = [17.4051564, 78.4927618];

  form: any | FormGroup
  marker2: any
  cid: any
  layerInfoLatLng: any = []
  objectTemplateList: any = []
  singleObjectTemplateData: any = []
  layerslist: any = []
  singleLayerData: any = []
  defaultZoom: any = 14
  defaultCenter: any = [17.4065, 78.4772]
  lat: any;
  lng: any
  selectAllChecked: any = false
  geojsonData:any = {
    "type": "FeatureCollection"
  }
  layerInfoData: any = []
  geojsonList: any = []
  
  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService,
    private resolver: ComponentFactoryResolver,
    private appRef: ApplicationRef,private router: Router,
    private injector: Injector) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      layerName: [''],
      layerColor: [''],
      layerLevel: ['']
    }) 
    this.cid = sessionStorage.getItem('cid')
    // this.initMap()
    this.getAllLayerInfo()
  }

  markerIcon = {
    icon: L.icon({
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [2, -40],
      // specify the path here
      iconUrl: "https://unpkg.com/leaflet@1.5.1/dist/images/marker-icon.png",
      shadowUrl: "https://unpkg.com/leaflet@1.5.1/dist/images/marker-shadow.png"
    })
  };

  private initMap(): void {
    console.log("initMap")

    this.map = L.map('map', {
      center: this.defaultCenter,
      zoom: this.defaultZoom
    });

    const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 22,
      minZoom: 2,
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    });

    tiles.addTo(this.map);


    if(this.layerInfoData != null && this.layerInfoData != undefined && this.layerInfoData.length != 0){
      for(let i = 0; i < this.layerInfoData.length; i++){
        let markerPopup: any = this.compilePopup(LayerPopupComponent,(c:any) => {c.instance.customData = this.layerInfoData[i]});
       let loc = L.marker(this.layerInfoData[i].latlang as L.LatLngExpression,{icon: this.defaultIcon}).bindPopup(
  
        markerPopup
       ).openPopup()
       loc.addTo(this.map)
      }
      tiles.addTo(this.map);
    }




    // this.map.on(L.Draw.Event.CREATED,  (event: any) => {
    //   const layer = event.layer;
 
    //   console.log(layer)
    //   console.log(event)
    //   console.log(layer._latlngs)
    //   drawnItems.addLayer(layer);

    //   if(event.layerType == "polygon"){
    //   drawnItems.addLayer(layer);

    //     for(let i=0;i < layer._latlngs[0].length;i++){
    //       this.layerInfoLatLng.push({
    //         lat: layer._latlngs[0][i].lat,
    //         lng: layer._latlngs[0][i].lng
    //       })
    //     }
    //     document.getElementById("add-layer-popup")?.click()
    //   }

    //   if(event.layerType == "marker"){
    //     this.lat = layer._latlng.lat
    //     this.lng = layer._latlng.lng
    //     // for(let i=0;i < layer._latlngs[0].length;i++){
    //     //   this.layerInfoLatLng.push({
    //     //     lat: layer._latlngs[0][i].lat,
    //     //     lng: layer._latlngs[0][i].lng
    //     //   })
    //     // }
    //     if(this.marker2 != undefined){
    //       this.map.removeLayer(this.marker2);
    //     }
    //     document.getElementById("add-device-popup")?.click()
    //   }

    // });

    // var drawnControl = new L.control.Draw();
    // this.map.addLayer(drawnControl);



    // const drawnItems = L.featureGroup().addTo(this.map);

    // const drawControl = new L.Control.Draw({
    //   edit: {
    //     featureGroup: drawnItems,
    //   },
    //   draw: {
    //     polygon: false,
    //     polyline: false,
    //     marker: false,
    //     circlemarker: false
    //   }
    // });
    // this.map.addControl(drawControl);

    // {
    //   return [
    //     new Leaflet.Polygon([
    //       new Leaflet.LatLng(43.5181349, 16.4537963),
    //       new Leaflet.LatLng(43.517890, 16.439939),
    //       new Leaflet.LatLng(43.515599, 16.446556),
    //       new Leaflet.LatLng(43.518025, 16.463492)
    //     ] as Leaflet.LatLng[],
    //       {
    //         fillColor: '#eb530d',
    //         color: '#eb780d'
    //       } as Leaflet.PolylineOptions)
    //   ] as Leaflet.Polygon[];
    // };

    if(this.singleLayerData.length != 0 && this.singleLayerData != undefined){
    console.log(this.singleLayerData)
    // let layerInfoLatLng = this.singleLayerData[0].latlang

      // for(let i=0;i<this.singleLayerData[0].layerInfoLatLng.length;i++){
 
      //   let obj:any = [
      //     this.singleLayerData[0].layerInfoLatLng[i].lat,
      //     this.singleLayerData[0].layerInfoLatLng[i].lng
      //   ]
      //   layerInfoLatLng.push(obj)
      // }
      // console.log(layerInfoLatLng)

      
      console.log(this.geojsonData)
      // console.log(this.geojsonData.features[0].geometry.coordinates)


    let geojsonLayer = L.geoJSON(this.geojsonData,{color: 'black',weight: 10});
    this.map.addLayer(geojsonLayer)

    }

    // let geojsonLayer = L.geoJSON(this.geojsonData,{color: 'red'});
    // this.map.addLayer(geojsonLayer)
  

  //   [
  //     {
  //         "lat": 20.212348320320977,
  //         "lng": 79.7278844886057
  //     },
  //     {
  //         "lat": 19.104239421473036,
  //         "lng": 80.27558503252313
  //     },
  //     {
  //         "lat": 18.649272584200144,
  //         "lng": 79.66491760454694
  //     },
  //     {
  //         "lat": 19.28366189827749,
  //         "lng": 78.39928631678355
  //     },
  //     {
  //         "lat": 20.25373167480533,
  //         "lng": 78.0814839725823
  //     }
  // ]
    



    // let geojsonLayer = L.geoJSON(this.geojsonData,{color: 'red'});
    //   this.map.addLayer(geojsonLayer)

  // drawnItems.addLayer(kk);

  // geojsonLayer.eachLayer(function(layer: any){
  //   layer.enableEdit()
  // });




    // var illustrateControl = new L.Illustrate.Control({
    //   edit: {
    //     featureGroup: drawnItems
    //   }
    // });
    // this.map.addControl(illustrateControl);


    // drawnItems.addLayer(
    //   new L.Illustrate.Pointer(L.latLng(41.7868010411136, -87.60601043701172), [
    //     new L.Point(0, 0),
    //     new L.Point(100, -100),
    //     new L.Point(400, -100)
    //   ])
    // );
    // drawnItems.addLayer(
    //   new L.Illustrate.Pointer(
    //     L.latLng(41.80219068741082, -87.60648250579834),
    //     [new L.Point(0, 0), new L.Point(100, -100), new L.Point(400, -100)]
    //   )
    // );

    // this.map.on("draw:created", function(evt:any) {
    //   var type = evt.layerType,
    //     layer = evt.layer;

    //   drawnItems.addLayer(layer);
    // });

    // this.map.on("click", e => {

    //   console.log(e.latlng);
    //   this.marker2 = new L.Marker(new L.LatLng(e.latlng.lat, e.latlng.lng),this.markerIcon);
    //   console.log(this.marker2);

    //   this.map.addLayer(this.marker2);
    // });


  }


  compilePopup(component:any, onAttach:any): any {
    const compFactory: any = this.resolver.resolveComponentFactory(component);
    let compRef: any = compFactory.create(this.injector);

    // onAttach allows you to assign 
    if (onAttach)
      onAttach(compRef);

    this.appRef.attachView(compRef.hostView);
    compRef.onDestroy(() => this.appRef.detachView(compRef.hostView));
    
    let div = document.createElement('div');
    div.appendChild(compRef.location.nativeElement);
    return div;
  }

  remove(){
    this.map.removeLayer(this.layerInfoLatLng);
    this.form.reset()
    document.getElementById("closeModalButton")?.click()
    console.log('close')
  }

  defaultIcon = L.icon({
    iconUrl: "https://unpkg.com/leaflet@1.5.1/dist/images/marker-icon.png",
    shadowUrl: "https://unpkg.com/leaflet@1.5.1/dist/images/marker-shadow.png",
    iconSize: [30, 30],
    iconAnchor: [15, 30],
    popupAnchor: [0, -30]
  });

  ngOnDestroy(){
    this.map.remove();
  }

  getAllLayerInfo(){
    this.generic_service.getAllLayerInfo().subscribe(
      (response: any)=>{
        console.log(response)
        for(let i=0;i<response.response.length;i++){
          response.response[i].isChecked = false
        }

        this.layerslist = response.response
        console.log(response.response)
        this.initMap();


      },
      (error: any)=>{
        console.log(error)
      }
    )
  }

  features:any = []

  getLayerInfoByLayerInfoId(layerInfoId: any){

    this.generic_service.getLayerInfoByLayerInfoId(layerInfoId).subscribe(
      (response: any)=>{
        // this.singleLayerData = []
        // for(let i=0;i<this.layerslist.length;i++){
        //   if(this.layerslist[i].layerInfoId == layerInfoId){
        //     this.layerslist[i].isChecked = !this.layerslist[i].isChecked
        //   }
        // }

        console.log(response)
        let latlang: L.LatLngExpression[] = []
        for(let i=0;i<response.response.layerInfoLatLng.length;i++){
 
          latlang.push(
            [
              parseFloat(response.response.layerInfoLatLng[i].lng),
              parseFloat(response.response.layerInfoLatLng[i].lat)
            ]
          )
          // response.response.layerInfoLatLng[i].lat = Number(response.response.layerInfoLatLng[i].lat)
          // response.response.layerInfoLatLng[i].lng = Number(response.response.layerInfoLatLng[i].lng)
        }
        // response.response.latlang = latlang
        this.defaultZoom = 14
        this.defaultCenter = [parseFloat(response.response.layerInfoLatLng[0].lat),parseFloat(response.response.layerInfoLatLng[0].lng)]
        this.singleLayerData.push(response.response)
        // console.log(this.singleLayerData)
        // this.geojsonData.features[0].geometry.coordinates = latlang
        let obj:any = {
          "type": "Feature",
          "layerColor": response.response.layerColor,
          "properties": {
            "name": "Polygon 1"
          },
          "geometry": {
            "type": "Polygon"
          }
        }
        if(response.response.layerType == 'Polygon' || response.response.layerType == 'polygon'){
          obj.geometry.coordinates = [latlang];
          obj.geometry.type = "Polygon";
          this.features.push(obj)
        }

        if(response.response.layerType == 'Polyline' || response.response.layerType == 'polyline'){
          obj.geometry.coordinates = latlang;
          obj.geometry.type = "LineString";
          this.features.push(obj)
        }


        // this.geojsonData = this.features
        this.getAllByLayerInfoId(layerInfoId)

        // this.initMap()
       
      },
      (error: any)=>{
        console.log(error)
      }
    )
  }

  selectAllGeo(){
    this.selectAllChecked = !this.selectAllChecked

    if(this.selectAllChecked){
      for(let i=0;i<this.layerslist.length;i++){
        this.layerslist[i].isChecked = true
      }
    }else{
      for(let i=0;i<this.layerslist.length;i++){
        this.layerslist[i].isChecked = false
      }
    }

    this.getAllSelectLayers()

  }

  atLeastOneChecked: any = false
  getLayers(layerInfoId: any){
    this.layerInfoData = []

    this.atLeastOneChecked = false
    for(let i=0;i<this.layerslist.length;i++){
      if(this.layerslist[i].layerInfoId == layerInfoId){
        this.layerslist[i].isChecked = !this.layerslist[i].isChecked
      }
    }
    this.features = []

    for(let i=0;i<this.layerslist.length;i++){
      if(this.layerslist[i].isChecked){
        this.getLayerInfoByLayerInfoId(this.layerslist[i].layerInfoId)
        this.atLeastOneChecked = true
      }
    }
    console.log(this.layerslist)

    this.map.remove();
    console.log(this.singleLayerData)

    if(!this.atLeastOneChecked){
      this.singleLayerData = []
      this.geojsonData = {}
      console.log(this.singleLayerData)
      console.log(this.geojsonData)

    }

    this.initMap()

  }


  getAllSelectLayers(){
    this.atLeastOneChecked = false
    this.features = []

    for(let i=0;i<this.layerslist.length;i++){
      if(this.layerslist[i].isChecked){
        this.getLayerInfoByLayerInfoId(this.layerslist[i].layerInfoId)
        this.atLeastOneChecked = true
      }
    }
    console.log(this.layerslist)

    this.map.remove();
    console.log(this.singleLayerData)

    if(!this.atLeastOneChecked){
      this.singleLayerData = []
      this.geojsonData = {}
      console.log(this.singleLayerData)
      console.log(this.geojsonData)

    }

    this.initMap()

  }


  getAllByLayerInfoId(id: any){

    this.generic_service.getAllByLayerInfoId(id).subscribe(
      (response: any)=>{
        console.log(response)
        this.map.remove();
        // this.layerInfoData = response.response

        let layerInfoData: any = []

        if(response.response != null && response.response != undefined && response.response.length != 0){
          for(let list of response.response){
            this.layerInfoData.push(list)
          }
        }


        for(let i=0;i<response.response.length;i++){
        let latlang: any = []
        let latlang1: any = []


          for(let j=0;j<response.response[i].nameValue.length;j++){

            if(response.response[i].nameValue[j].key == 'Lng'){
              latlang.push(parseFloat(response.response[i].nameValue[j].value))
            }
            if(response.response[i].nameValue[j].key == 'Lat'){
              latlang.push(parseFloat(response.response[i].nameValue[j].value))
            }
          }
          response.response[i].latlang = latlang


          console.log(response)
          console.log(this.layerInfoData)
          let obj1:any = {
            "type": "Feature",
            "layerColor": response.response.layerColor,
            "properties": {
              "name": "point 1"
            },
            "geometry": {
              "type": "Point"
            }
          }
  
          obj1.geometry.coordinates = [latlang[1],latlang[0]];
          // this.features.push(obj1)
          
          // response.response.layerInfoLatLng[i].lat = Number(response.response.layerInfoLatLng[i].lat)
          // response.response.layerInfoLatLng[i].lng = Number(response.response.layerInfoLatLng[i].lng)
        }


        this.geojsonData = this.features
        // this.geojsonList.push(this.geojsonData)
        this.initMap()


      },
      (error: any)=>{
        console.log(error)
        this.initMap()

      }
    )
  }

}
